import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import articlesStore_1 from "../store/articlesStore_1";
import articlesStore_2 from "../store/articlesStore_2";
import articlesStore_3 from "../store/articlesStore_3";
let articlesStore=[articlesStore_1,articlesStore_2,articlesStore_3]


Vue.use(Router)
const router=new Router({
  routes: [
    {
      path: '/ArticleList/:class',
      name: 'ArticleList'
    },
    {
      path: '/Article/:id/:issue/:class',
      name: 'Article'
    },
    {
      path: '*',
      redirect:'/ArticleList/1'
    }
  ]
})

router.afterEach((to,from)=>{
  let ShareInfo
  switch (to.name){
    case 'ArticleList':
      ShareInfo={
        title:"动见|把买卖做成生意，本地生活生意经",
        desc: "小微企业用创新实现了2020年“V”型反转，而社会与平台的作用和意义是用产品和工具授之以渔，实现数字普惠。",
        link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_3.html?chanel=1",
        icon: "icon.jpg",
        count:0,
        issue:3
      }
      store.commit('setShareInfo',ShareInfo);
      break;
    case 'Article':
      let thisArticle=articlesStore[to.params.issue-1].state.articles[to.params.id-1]
      ShareInfo={
        title:thisArticle.share_title,
        desc: thisArticle.share_des,
        link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_3.html?chanel=1#/Article/"+to.params.id+"/"+to.params.issue+"/"+to.params.class,
        icon: to.params.issue+"/"+to.params.id+"/"+"share.jpg",
        count:to.params.id,
        issue:to.params.issue
      }
      store.commit('setShareInfo',ShareInfo);
      break;
    default:
      ShareInfo={
        title:"动见|把买卖做成生意，本地生活生意经",
        desc: "小微企业用创新实现了2020年“V”型反转，而社会与平台的作用和意义是用产品和工具授之以渔，实现数字普惠。",
        link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_3.html?chanel=1",
        icon: "icon.jpg",
        count:0,
        issue:3
      }
      store.commit('setShareInfo',ShareInfo);
      break;
  }
  console.log(to)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js